Array.prototype.sortBy = function (key) {
    return this.sort((a, b) => (a[key] > b[key]) ? 1 : -1);
};
